/* LUMORA Instrument
   No scroll listeners anywhere: IntersectionObserver only. Everything here is
   progressive enhancement. With JS off, the product form and the cart form
   still post normally and the shop still sells. All user-facing strings come
   from window.LUMORA.t, which Shopify resolves per locale. */

(function () {
  'use strict';

  var L = window.LUMORA || { t: {} };
  var T = L.t || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------------------------------------------------------- reveal */

  /* Edytor motywu podmienia HTML sekcji po każdej zmianie ustawienia. Nowe
     węzły mają data-reveal, ale nie zna ich żaden obserwator założony przy
     ładowaniu strony — bez ponownego podpięcia sekcja zostaje na opacity: 0
     i redaktor widzi pusty prostokąt zamiast swojej zmiany. Dlatego wszystko,
     co dotyczy sekcji, jest tu funkcją przyjmującą zakres, a nie pętlą po
     całym dokumencie wykonaną raz. */

  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var io = null;

  function wireReveal(root) {
    var targets = root.querySelectorAll('[data-reveal], [data-stagger]');
    /* W edytorze odsłaniamy od razu: redaktor ocenia treść, nie wejście,
       a sekcja przeładowana poza kadrem nigdy by się nie pokazała. */
    if (reduce || designMode || !io) {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-in');
      return;
    }
    for (var j = 0; j < targets.length; j++) io.observe(targets[j]);
  }

  if (!(reduce || !('IntersectionObserver' in window))) {
    /* threshold: 0, nie ułamek wysokości elementu. Przy progu 0.15 sekcje
       wyższe od okna nigdy go nie osiągają — maksymalny możliwy stosunek to
       wysokość okna podzielona przez wysokość elementu — więc tabela
       specyfikacji czy siatka kafli zostawały niewidoczne na zawsze.
       Wejście ma się zacząć, gdy element dotknie kadru, i tyle. */
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
  }

  /* ------------------------------------------------- transmission curve ---
     The line draws left to right so the eye follows the wall up to 560 nm
     before the curve opens. The motion carries the argument of the section. */

  function wireTraces(root) {
    var traces = root.querySelectorAll('.trace-draw');
    for (var k = 0; k < traces.length; k++) {
      try {
        traces[k].style.setProperty('--len', traces[k].getTotalLength());
      } catch (err) {
        traces[k].classList.remove('trace-draw');
      }
    }
  }

  /* ------------------------------------------------------ chart instrument --
     Punkty istnieją w pliku raz, w atrybucie polyline. Pole pod krzywą, tor
     znacznika i odczyt liczą się z nich, więc nie da się ich rozjechać przy
     kolejnej edycji danych. Wszystko poniżej to nadbudowa: bez skryptu
     zostaje czytelna linia z podpisami. */

  function parsePoints(node) {
    var raw = (node.getAttribute('points') || '').trim().split(/[\s,]+/);
    var pts = [];
    for (var i = 0; i + 1 < raw.length; i += 2) {
      pts.push([parseFloat(raw[i]), parseFloat(raw[i + 1])]);
    }
    return pts;
  }

  /* Oś x wykresu: x = 0 to 280 nm, każde 20 jednostek to 10 nm.
     Oś y: 400 to zero procent, 0 to sto procent. */
  function toNm(x) { return 280 + x / 2; }
  function toPct(y) { return (400 - y) / 4; }

  /* Separator dziesiętny idzie za lokalizacją sklepu, nie za nazwą funkcji:
     przy angielskiej wersji „1,81%" czytałoby się jak tysiące. */
  var comma = (L.locale || 'pl').slice(0, 2) !== 'en';

  function pl(n, digits) {
    var s = n.toFixed(digits === undefined ? 2 : digits);
    return comma ? s.replace('.', ',') : s;
  }

  function wireCharts(root) {
    var charts = root.querySelectorAll('[data-chart]');
    for (var c = 0; c < charts.length; c++) initChart(charts[c]);
  }

  function initChart(chart) {
    {
      var svg = chart.querySelector('svg');
      var line = chart.querySelector('.trace');
      if (!svg || !line) return;

      var pts = parsePoints(line);
      if (pts.length < 2) return;

      var d = 'M' + pts.map(function (p) { return p[0] + ',' + p[1]; }).join(' L');

      var area = chart.querySelector('[data-area]');
      if (area) {
        area.setAttribute('d', d + ' L' + pts[pts.length - 1][0] + ',400 L' + pts[0][0] + ',400 Z');
      }

      var rider = chart.querySelector('[data-rider]');
      if (rider) rider.style.setProperty('--path', 'path("' + d + '")');

      var cursor = chart.querySelector('[data-cursor]');
      var hit = chart.querySelector('[data-hit]');
      var outNm = chart.querySelector('[data-read-nm]');
      var outT = chart.querySelector('[data-read-t]');
      var outB = chart.querySelector('[data-read-b]');
      if (!cursor || !hit || !outNm) return;

      var idx = -1;

      /* ---------------------------------------------- emisja kontra soczewka
         Krzywa transmisji jest pomiarem i mieszka w pliku. Widma źródeł są
         przełączalne, więc liczy je skrypt — i dlatego cała ta warstwa jest
         nadbudową, która bez JS po prostu nie istnieje. */

      var emitFill = chart.querySelector('[data-emit-fill]');
      var blockFill = chart.querySelector('[data-block-fill]');
      var passFill = chart.querySelector('[data-pass-fill]');
      var emitLine = chart.querySelector('[data-emit-line]');
      var emitRest = chart.querySelector('[data-emit-rest]');
      var passLine = chart.querySelector('[data-pass-line]');
      var annotVal = chart.querySelector('[data-annot-val]');
      var bandOut = chart.querySelectorAll('[data-band]');
      var lensBtn = chart.querySelector('[data-lens-toggle]');

      var hasLayers = emitFill && blockFill && passFill && emitLine && passLine;

      if (hasLayers) {
        chart.classList.add('is-live');

        /* Transmisja przy dowolnej długości fali, interpolowana liniowo między
           zmierzonymi punktami. Nie zmyślamy wartości pośrednich, tylko łączymy
           te, które są w raporcie. */
        function trans(nm) {
          var u = (nm - 280) * 2;
          var i = Math.floor(u / 20);
          if (i < 0) i = 0;
          if (i > pts.length - 2) i = pts.length - 2;
          var a = toPct(pts[i][1]);
          var b = toPct(pts[i + 1][1]);
          return a + (b - a) * ((u - i * 20) / 20);
        }

        function bell(nm, mid, width) {
          var z = (nm - mid) / width;
          return Math.exp(-(z * z) / 2);
        }

        /* Typowe rozkłady widmowe, nie pomiary. Biały LED to wąski pik diody
           niebieskiej plus szeroki garb luminoforu; OLED i telewizor mają trzy
           osobne emitery. Zastrzeżenie stoi w stopce wykresu. */
        var SOURCES = {
          laptop: function (nm) { return 0.95 * bell(nm, 450, 13) + 0.80 * bell(nm, 545, 52) + 0.28 * bell(nm, 615, 42); },
          phone:  function (nm) { return 0.78 * bell(nm, 462, 15) + 0.92 * bell(nm, 528, 24) + 0.86 * bell(nm, 620, 20); },
          tv:     function (nm) { return 0.90 * bell(nm, 448, 12) + 0.70 * bell(nm, 538, 30) + 0.75 * bell(nm, 632, 26); },
          lamp:   function (nm) { return 0.60 * bell(nm, 452, 14) + 1.00 * bell(nm, 570, 62); }
        };

        var STEP = 2;                       /* nm — gęściej niż pomiar, bo pik ma 13 nm */
        var WAVES = [];
        for (var nm = 380; nm <= 780; nm += STEP) WAVES.push(nm);

        var TR = WAVES.map(trans);          /* transmisja liczona raz, nie w każdej klatce */

        function build(key) {
          var raw = WAVES.map(SOURCES[key]);
          var max = Math.max.apply(null, raw);
          return raw.map(function (v) { return v / max; });
        }

        function X(nm) { return (nm - 280) * 2; }
        function Y(v) { return 400 - v * 400; }

        function curveD(vals, from) {
          var d = '';
          for (var i = 0; i < vals.length; i++) {
            if (from !== undefined && WAVES[i] < from) continue;
            d += (d ? 'L' : 'M') + X(WAVES[i]).toFixed(1) + ',' + Y(vals[i]).toFixed(1) + ' ';
          }
          return d;
        }
        function areaD(vals) {
          return curveD(vals) + 'L' + X(WAVES[WAVES.length - 1]) + ',400 L' + X(WAVES[0]) + ',400 Z';
        }
        /* Zablokowane to powierzchnia między emisją a tym, co przeszło:
           w dół po jednej krzywej, w górę po drugiej. */
        function ribbonD(top, bottom) {
          var d = curveD(top);
          for (var i = bottom.length - 1; i >= 0; i--) {
            d += 'L' + X(WAVES[i]).toFixed(1) + ',' + Y(bottom[i]).toFixed(1) + ' ';
          }
          return d + 'Z';
        }

        var series = build('laptop');       /* cel */
        var shown = series.slice();         /* to, co narysowane w tej klatce */
        var wantK = 1, haveK = 1;           /* 1 = okulary założone */
        var anim = 0;

        function passOf(vals, k) {
          return vals.map(function (v, i) { return v * (1 - k + k * TR[i] / 100); });
        }

        function paintChart() {
          var pass = passOf(shown, haveK);
          emitFill.setAttribute('d', areaD(shown));
          emitLine.setAttribute('d', curveD(shown));
          blockFill.setAttribute('d', ribbonD(shown, pass));
          passFill.setAttribute('d', areaD(pass));
          passLine.setAttribute('d', curveD(pass));
          if (emitRest) emitRest.setAttribute('d', curveD(shown, 500));
        }

        /* Udział światła zatrzymanego w paśmie. Liczony z widma, nie ze średniej
           transmisji: ekran nie świeci równo, więc ważne jest, gdzie ma pik. */
        function blockedIn(lo, hi) {
          var total = 0, through = 0;
          for (var i = 0; i < WAVES.length; i++) {
            if (WAVES[i] < lo || WAVES[i] > hi) continue;
            total += series[i];
            through += series[i] * (1 - haveK + haveK * TR[i] / 100);
          }
          return total ? (1 - through / total) * 100 : 0;
        }

        function paintNumbers() {
          if (annotVal) annotVal.textContent = pl(blockedIn(380, 500), 1) + '%';
          for (var i = 0; i < bandOut.length; i++) {
            var range = bandOut[i].getAttribute('data-band').split(',');
            var v = blockedIn(parseFloat(range[0]), parseFloat(range[1]));
            if (bandOut[i].hasAttribute('data-invert')) v = 100 - v;
            bandOut[i].textContent = pl(v, 1) + '%';
          }
        }

        function frame(nextSeries, nextK) {
          var fromSeries = shown.slice();
          var fromK = haveK;
          var t0 = 0;
          var span = reduce ? 1 : 620;

          if (anim) window.cancelAnimationFrame(anim);

          function step(now) {
            if (!t0) t0 = now;
            var p = Math.min(1, (now - t0) / span);
            var e = 1 - Math.pow(1 - p, 3);
            shown = fromSeries.map(function (v, i) { return v + (nextSeries[i] - v) * e; });
            haveK = fromK + (nextK - fromK) * e;
            paintChart();
            paintNumbers();
            anim = p < 1 ? window.requestAnimationFrame(step) : 0;
          }
          anim = window.requestAnimationFrame(step);
        }

        paintChart();
        paintNumbers();

        /* Wejście: pole emisji podnosi się od zera razem z rysowaniem krzywej
           transmisji, więc wykres czyta się jak jeden zapis. */
        if (!reduce && 'IntersectionObserver' in window) {
          shown = series.map(function () { return 0; });
          paintChart();
          var enter = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              enter.unobserve(e.target);
              frame(series, wantK);
            });
          }, { rootMargin: '0px 0px -18% 0px' });
          enter.observe(chart);
        }

        var srcBtns = chart.querySelectorAll('[data-src]');
        for (var b = 0; b < srcBtns.length; b++) {
          srcBtns[b].addEventListener('click', function (ev) {
            var btn = ev.currentTarget;
            for (var n = 0; n < srcBtns.length; n++) {
              srcBtns[n].setAttribute('aria-pressed', String(srcBtns[n] === btn));
            }
            series = build(btn.getAttribute('data-src'));
            frame(series, wantK);
          });
        }

        if (lensBtn) {
          lensBtn.addEventListener('click', function () {
            wantK = wantK ? 0 : 1;
            lensBtn.setAttribute('aria-pressed', String(!!wantK));
            var label = lensBtn.querySelector('[data-lens-label]');
            if (label) {
              label.textContent = lensBtn.getAttribute(wantK ? 'data-on' : 'data-off') || label.textContent;
            }
            frame(series, wantK);
          });
        }
      }

      function show(i) {
        if (i < 0) i = 0;
        if (i > pts.length - 1) i = pts.length - 1;
        if (i === idx) return;
        idx = i;

        var p = pts[i];
        var pct = toPct(p[1]);

        cursor.setAttribute('transform', 'translate(' + p[0] + ' 0)');
        cursor.querySelector('circle').setAttribute('cy', p[1]);

        outNm.textContent = Math.round(toNm(p[0])) + ' nm';
        if (outT) outT.textContent = pl(pct) + '%';
        if (outB) outB.textContent = pl(100 - pct) + '%';

        chart.classList.add('is-reading');
      }

      function fromEvent(ev) {
        var box = svg.getBoundingClientRect();
        if (!box.width) return;
        /* Skala brana z viewBoxa, a nie wpisana na sztywno: zmiana kadru
           wykresu w pliku nie rozjedzie wtedy odczytu. */
        var vb = svg.viewBox.baseVal;
        var units = (ev.clientX - box.left) / box.width * vb.width + vb.x;
        show(Math.round(units / 20));
      }

      svg.addEventListener('pointermove', fromEvent);
      svg.addEventListener('pointerdown', fromEvent);
      svg.addEventListener('pointerleave', function () {
        chart.classList.remove('is-reading');
        idx = -1;
      });

      svg.addEventListener('keydown', function (ev) {
        var step = 0;
        if (ev.key === 'ArrowRight') step = 1;
        else if (ev.key === 'ArrowLeft') step = -1;
        else if (ev.key === 'Home') { ev.preventDefault(); show(0); return; }
        else if (ev.key === 'End') { ev.preventDefault(); show(pts.length - 1); return; }
        if (!step) return;
        ev.preventDefault();
        show((idx < 0 ? 14 : idx) + step * (ev.shiftKey ? 5 : 1));
      });

      svg.addEventListener('blur', function () {
        chart.classList.remove('is-reading');
        idx = -1;
      });
    }
  }

  /* ------------------------------------------------ lens comparison ------
     The native range input does the dragging, the keyboard and the screen
     reader announcement. All this adds is the paint. Without JS the stage
     stays cut at 50% and the slider hides itself, so nothing pretends to
     be interactive when it is not. */

  function wireLens(root) {
    var stages = root.querySelectorAll('[data-lens]');
    for (var s = 0; s < stages.length; s++) initLens(stages[s]);
  }

  function initLens(stage) {
    {
      var range = stage.querySelector('[data-lens-range]');
      if (!range) return;

      stage.classList.add('is-live');

      var frame = 0;
      function paint() {
        frame = 0;
        stage.style.setProperty('--p', range.value + '%');
      }
      /* Dotknięcie suwaka przerywa animację wejścia. Bez tego przez pierwsze
         900 ms ciągnięcie walczyłoby z tym, co robi animacja. */
      function takeOver() {
        if (!stage.getAnimations) return;
        stage.getAnimations().forEach(function (a) { a.cancel(); });
      }

      range.addEventListener('pointerdown', takeOver);
      range.addEventListener('keydown', takeOver);

      range.addEventListener('input', function () {
        if (frame) return;
        frame = window.requestAnimationFrame(paint);
      });

      paint();
    }
  }

  /* ------------------------------------------------------------- helpers */

  function money(cents) {
    try {
      return new Intl.NumberFormat(L.locale || 'pl-PL', {
        style: 'currency',
        currency: L.currency || 'PLN'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function announce(msg) {
    var live = document.getElementById('cart-live');
    if (live) live.textContent = msg;
  }

  function paintCount(count) {
    var nodes = document.querySelectorAll('[data-cart-count]');
    for (var n = 0; n < nodes.length; n++) {
      nodes[n].textContent = ' (' + count + ')';
      nodes[n].setAttribute('data-count', count);
    }
  }

  function readCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* --------------------------------------------------------- localization -
     Changing country or language is a navigation, not a form to fill in, so
     the selects submit themselves. The button stays for the no-JS case. */

  var locForms = document.querySelectorAll('[data-loc]');
  for (var f = 0; f < locForms.length; f++) {
    (function (form) {
      var go = form.querySelector('.loc-go');
      if (go) go.hidden = true;
      form.addEventListener('change', function (ev) {
        if (ev.target.tagName === 'SELECT') form.submit();
      });
    })(locForms[f]);
  }

  /* -------------------------------------------------------- add to cart ---
     Reloading the page to confirm one click is the slowest possible feedback.
     The button states itself and the header count updates instead. */

  /* Formularzy zakupu bywa na stronie więcej niż jeden: karta produktu ma swój,
     a strona główna blok produktowy. Każdy dostaje własną obsługę, żeby drugi
     nie przeładowywał strony tylko dlatego, że jest drugi. */
  function wireAddForms(root) {
    var addForms = root.querySelectorAll('[data-add-form]');
    for (var af = 0; af < addForms.length; af++) bindAddForm(addForms[af]);
  }

  function bindAddForm(addForm) {
    if (!window.fetch) return;
    addForm.addEventListener('submit', function (ev) {
      ev.preventDefault();

      var btn = addForm.querySelector('[data-add-btn]');
      var label = addForm.querySelector('[data-add-label]');
      var err = addForm.querySelector('[data-add-error]');
      var original = label ? label.textContent : '';
      /* Formularz niesie return_to, więc bez skryptu też trafi do płatności.
         Tutaj przekierowujemy sami, żeby nie płacić za to przeładowaniem. */
      var buyNow = addForm.getAttribute('data-buy-now') === 'true';

      if (err) { err.textContent = ''; err.hidden = true; }
      if (btn) btn.setAttribute('aria-busy', 'true');
      if (label) label.textContent = (buyNow ? T.going : T.adding) || original;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(addForm)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || T.addError);
            return data;
          });
        })
        .then(function () {
          if (buyNow) {
            /* Nie ruszamy etykiety ani licznika: strona i tak za chwilę
               zniknie, a migotanie napisu przed skokiem wygląda na usterkę. */
            window.location.href = L.checkout || '/checkout';
            return null;
          }
          if (label) label.textContent = T.added || original;
          announce(T.cartAdded || '');
          return readCart().then(function (c) { paintCount(c.item_count); });
        })
        .catch(function (e) {
          if (label) label.textContent = original;
          if (err) { err.textContent = e.message || T.addError; err.hidden = false; }
          announce(e.message || T.addError || '');
        })
        .then(function () {
          if (buyNow) return;
          if (btn) btn.removeAttribute('aria-busy');
          window.setTimeout(function () {
            if (label && label.textContent === T.added) label.textContent = original;
          }, 2600);
        });
    });
  }

  /* ------------------------------------------------------------ cart page */


  var cart = document.querySelector('[data-cart]');
  if (cart && window.fetch) {
    var busy = false;

    function setBusy(state) {
      busy = state;
      cart.setAttribute('aria-busy', state ? 'true' : 'false');
      cart.classList.toggle('is-busy', state);
    }

    function repaint(data) {
      paintCount(data.item_count);

      if (data.item_count === 0) {
        window.location.reload();
        return;
      }

      var rows = cart.querySelectorAll('[data-key]');
      for (var r = rows.length - 1; r >= 0; r--) {
        var key = rows[r].getAttribute('data-key');
        var line = null;
        for (var d = 0; d < data.items.length; d++) {
          if (data.items[d].key === key) { line = data.items[d]; break; }
        }
        if (!line) { rows[r].remove(); continue; }

        var price = rows[r].querySelector('[data-line-price]');
        if (price) price.textContent = money(line.final_line_price);
        var qty = rows[r].querySelector('[data-qty]');
        if (qty) qty.value = line.quantity;
      }

      var total = cart.querySelector('[data-cart-total]');
      if (total) total.textContent = money(data.total_price);

      announce((T.cartUpdated || '') + ' ' + (T.subtotal || '') + ' ' + money(data.total_price));
    }

    function change(key, quantity) {
      if (busy) return;
      setBusy(true);

      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(repaint)
        .catch(function () { window.location.reload(); })
        .then(function () { setBusy(false); });
    }

    cart.addEventListener('click', function (ev) {
      var step = ev.target.closest('[data-step]');
      if (step) {
        ev.preventDefault();
        var row = step.closest('[data-key]');
        var input = row.querySelector('[data-qty]');
        var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-step'), 10);
        if (next < 0) next = 0;
        input.value = next;
        change(row.getAttribute('data-key'), next);
        return;
      }

      var kill = ev.target.closest('[data-remove]');
      if (kill) {
        ev.preventDefault();
        change(kill.closest('[data-key]').getAttribute('data-key'), 0);
      }
    });

    cart.addEventListener('change', function (ev) {
      var input = ev.target.closest('[data-qty]');
      if (!input) return;
      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      change(input.closest('[data-key]').getAttribute('data-key'), value);
    });
  }

  /* ------------------------------------------------------------- start ---
     Jeden punkt wejścia dla dokumentu i dla pojedynczej sekcji. Edytor motywu
     po każdej zmianie ustawienia wstawia świeży HTML sekcji i emituje
     shopify:section:load — bez tego nasłuchu podmieniona sekcja nie zostałaby
     odsłonięta ani ożywiona, więc redaktor widziałby pusty prostokąt. */

  function initScope(root) {
    wireReveal(root);
    wireTraces(root);
    wireCharts(root);
    wireLens(root);
    wireAddForms(root);
  }

  initScope(document);

  document.addEventListener('shopify:section:load', function (ev) {
    initScope(ev.target);
  });

  /* -------------------------------------------------------- pdp gallery */

  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.addEventListener('click', function (ev) {
      var pick = ev.target.closest('[data-gallery-pick]');
      if (!pick || !main) return;

      var src = pick.getAttribute('data-src');
      if (!src) return;

      main.src = src;
      var set = pick.getAttribute('data-srcset');
      if (set) main.srcset = set;
      main.alt = pick.getAttribute('data-alt') || '';

      var all = gallery.querySelectorAll('[data-gallery-pick]');
      for (var g = 0; g < all.length; g++) all[g].setAttribute('aria-current', 'false');
      pick.setAttribute('aria-current', 'true');
    });
  }
})();
